import Phaser from 'phaser';
import { UIManager } from '../managers/UIManager.js';
import { SoundManager } from '../managers/SoundManager.js';
import { CONSTANTS } from '../game.js';

/**
 * サウンドテストシーン
 * 各種サウンドをテストするための画面
 */
export class SoundTestScene extends Phaser.Scene {
    constructor() {
        super({ key: 'SoundTestScene' });
        
        // UIコンポーネント
        this.backButton = null;
        this.titleText = null;
        
        // 背景
        this.brickBackground = null;
        
        // UIマネージャー
        this.uiManager = null;
        
        // サウンドマネージャー
        this.soundManager = null;
    }

    create() {
        console.log('SoundTestScene: Create function called');
        
        // UIマネージャーの初期化
        this.uiManager = new UIManager(this);
        
        // サウンドマネージャーの初期化
        this.soundManager = new SoundManager(this);
        
        // デスクトップの場合のみカーソルをポインタに
        if (!this.game.device.input.touch) {
            this.input.setDefaultCursor('pointer');
        }
        
        // 背景色の設定
        this.cameras.main.setBackgroundColor('#87CEEB');
        
        // レンガの背景を作成
        this.createBrickBackground();
        
        // タイトルテキスト
        this.createTitleText();
        
        // サウンドテストボタン
        this.createSoundTestButtons();
        
        // 戻るボタン
        this.createBackButton();
        
        // リビジョン情報の表示
        this.uiManager.createRevisionText();
        
        console.log('SoundTestScene: Create function completed');
    }
    
    /**
     * レンガの背景を作成する
     */
    createBrickBackground() {
        // 画面サイズを取得
        const width = this.game.config.width;
        const height = this.game.config.height;
        
        // TileSpriteとして背景を作成（画面より大きめに）
        this.brickBackground = this.add.tileSprite(
            width / 2,    // x位置（中央）
            height / 2,   // y位置（中央）
            width + 100,  // 幅（画面より少し大きく）
            height + 100, // 高さ（画面より少し大きく）
            'brick'       // テクスチャキー
        );
        
        // 背景を最背面に配置
        this.brickBackground.setDepth(-100);
        
        // 背景のスライドアニメーション
        this.tweens.add({
            targets: this.brickBackground,
            tilePositionX: { from: 0, to: 100 },
            tilePositionY: { from: 0, to: 100 },
            ease: 'Linear',
            duration: 20000,
            repeat: -1
        });
    }
    
    /**
     * タイトルテキストを作成する
     */
    createTitleText() {
        this.titleText = this.add.text(
            this.game.config.width / 2,
            this.game.config.height / 6,
            'SOUND TEST',
            {
                fontSize: '48px',
                fontStyle: 'bold',
                fontFamily: 'DotGothic16',
                fill: '#ffffff',
                stroke: '#000000',
                strokeThickness: 6
            }
        );
        this.titleText.setOrigin(0.5);
        
        // タイトルのアニメーション
        this.tweens.add({
            targets: this.titleText,
            y: this.titleText.y - 10,
            duration: 1500,
            ease: 'Sine.easeInOut',
            yoyo: true,
            repeat: -1
        });
    }
    
    /**
     * サウンドテストボタンを作成
     */
    createSoundTestButtons() {
        // 評価ごとのサウンドテストボタン
        const evaluations = ['PERFECT', 'GREAT', 'GOOD', 'PASS', 'FAIL'];
        const colors = {
            'PERFECT': { bg: '#9C27B0', hover: '#7B1FA2' },
            'GREAT': { bg: '#F44336', hover: '#D32F2F' },
            'GOOD': { bg: '#4CAF50', hover: '#388E3C' },
            'PASS': { bg: '#2196F3', hover: '#1976D2' },
            'FAIL': { bg: '#9E9E9E', hover: '#757575' }
        };
        
        // 開始位置を上げる（1/3から1/4へ）
        let yPos = this.game.config.height / 4;
        
        evaluations.forEach(evaluation => {
            this.uiManager.createButton(
                yPos,
                `${evaluation} HIT SOUND`,
                {
                    backgroundColor: colors[evaluation].bg,
                    hoverColor: colors[evaluation].hover,
                    fontSize: '30px' // フォントサイズを小さく
                },
                () => {
                    // SoundManagerを使用してサウンドを再生
                    this.soundManager.playTargetHitSound(CONSTANTS.EVALUATION.TEXT[evaluation]);
                }
            );
            yPos += 60; // ボタン間の間隔を縮める（80pxから60pxへ）
        });
        
        // クリティカルサウンドテストボタン
        this.uiManager.createButton(
            yPos,
            'CRITICAL SOUND',
            {
                backgroundColor: '#FF9800',
                hoverColor: '#F57C00',
                fontSize: '30px' // フォントサイズを小さく
            },
            () => {
                // SoundManagerを使用してクリティカルサウンドを再生
                this.soundManager.playCriticalSound();
            }
        );
    }
    
    /**
     * 戻るボタンを作成する
     */
    createBackButton() {
        this.backButton = this.uiManager.createButton(
            this.game.config.height - 80, // 位置を調整（-100から-80へ）
            'BACK TO SETTINGS',
            {
                backgroundColor: '#2196F3',
                hoverColor: '#1976D2',
                fontSize: '36px' // 戻るボタンのサイズも調整
            },
            () => {
                // SettingSceneに遷移
                this.scene.start('SettingScene');
            }
        );
    }
    
    update() {
        // 必要に応じて更新処理を追加
    }
}
